import coworkUtils from "@/js/store/module/common/coworkUtils";
import evdControl from "@/js/store/module/common/evdControl";
/**
 * 보드유틸정의 
 * 보드의 각종 컴포넌트에서 자주 사용되는 메소드, 상수 등을 모아둔다.
 * 주로 편집기능 에 관련된 사항만 모아둠
 * BoardContent 에서 활성화 되는 메소드 들과
 * BoardEditor 에서 활성화 되는 메소드 들이 있으며
 * 각각
 * 
 * initBoardContent
 * initBoardEditor
 * 
 * 에서 나뉘어 활성화 된다.
 * 
 * 기타 ContentBlock 에서 사용되는 메소드는 직접 ContentBlock 인자를 넘겨서 수행한다.
 **/

////////////////////////////////////////////////////////////////////////////////
// 상수

/* 한화편집기 고정 색상표 */
const HW_EDITOR_GLOBAL_COLORS = [
  "#000000", "#666666", "#999999",
  "#b8814c", "#f97723", "#eca90f",
  "#f3da33", "#ff0000", "#0024ff",
  "#34a6db", "#794ccd", "#682007",
  "#15a293", "#a2c10b", "#259c00",
  "#ed67cc"
];

/* 편집기블럭 타입들 */
const HW_BLOCK_TYPES = {
  CONTENT   : "CONTENT",
  FILE      : "FILE",
  IMAGE     : "IMAGE",
  IMAGELINK : "IMAGELINK",
  TABLE     : "TABLE",
  LINK      : "LINK",
  LINE      : "LINE",
  TODO      : "TODO",
  DECISION  : "DECISION"
};

/* 블럭소유(편집)상태들 */
const HW_OWN_TYPES = {
  OWNER   : "owner",
  ANOTHER : "another",
  NOBODY  : "nobody"
};

const KEYCODES = evdControl.state.KEYCODES;

const EVENT_TYPES = evdControl.state.EVENT_TYPES;

const HW_KEYGEN = coworkUtils.actions.HW_KEYGEN;

const FILE_TYPES = {
  IMAGE:    "image",
  DOCUMENT: "document",
  SHEET:    "sheet",
  PRESENT:  "present",
  ARCHIVE:  "archive",
  ETC:      "etc"
};

const FILE_EXT = {
  image: [
    "jpg", "jpeg", "png", "apng", "gif", "bmp", "tif", "tiff", "ps", "eps", "svg"
  ],
  document: [
    "doc", "docx", "hwp", "txt", "rtf", "pdf",
  ],
  sheet: [
    "xls", "xlsx"
  ],
  present: [
    "ppt", "pptx"
  ],
  archive: [
    "zip", "rar", "7z", "alz", "gz", "tgz", "bz", "tbz", "xz", "txz",
  ],
  etc: []
};

let testmode = false;
{
  let match = /^(.+)\/(board|boardViewer)\/(PAPE[a-zA-Z0-9]+)([/?].*){0,1}/.exec(
    window.location.href
  );
  if (match && match.length > 4 && match[4]) {
    let str = match[4].replace(/^[/?]+/g, "");
    if (str === "test=test") {
      testmode = true;
    }
  }
}

const tracelog = function() {
  if (testmode) { if (arguments) { console.log(arguments[0], arguments); } }
};
const dumpAttr = function(obj) {
  if (testmode) {
    let attrs = ""; for (let key in obj) { attrs += " " + key; } console.log("ATTRS:" + attrs);
  }
};

const CHECK_AND_LAUNCH = coworkUtils.actions.CHECK_AND_LAUNCH;

let BoardUtil = {
////////////////////////////////////////////////////////////////////////////////
// 데이터

  /* 통신시 자가발신 메시지는 송신하지 않도록 리스트 구성 */
  updateTokens  : [ ],

  /* 소유하고 있는 블럭 엘리먼트 */
  blockOwned    : null,

  /* 상수들 매핑 */
  colors           : HW_EDITOR_GLOBAL_COLORS,
  blockTypes       : HW_BLOCK_TYPES,
  ownTypes         : HW_OWN_TYPES,
  keyCodes         : KEYCODES,
  eventTypes       : EVENT_TYPES,
  fileTypes        : FILE_TYPES,
  fileExt          : FILE_EXT,
  blockConstructor : { },
  userPhotoCache   : [[], {}],

////////////////////////////////////////////////////////////////////////////////
// 메소드

  /* BoardContent 에서 활성화 시킬수 있는 함수들 */
  initBoardContent(self, axios) {
    self.tracelog = tracelog;
    let boardUtil = this;
    let userPhotoWorkQueue = [ ];
    /* DOM Manipulator 탐색 단축용. 많이 쓰는 키워드를 단축해서 사용할수 있음. */
    boardUtil.$dm = function(element, preventNull) {
      let map = function (element) {
        if (element) {
          element.pr = function (n) {
            let e = element;
            if (n < 1) { n = 1; }
            for (let inx = 0; inx < n; inx++) {
              e = e.parentElement;
            }
            return map(e.parentElement);
          };
          element.ps = function (cl, n = -1) {
            let e = element.parentElement;
            while (e) {
              let clss = e.getAttribute("class");
              if (clss && clss.indexOf(cl) != -1) {
                break;
              }
              e = e.parentElement;
            }
            return map(e);
          };
          element.cl = function () { return element.classList; };
          element.clf = function (n) {
            for (let inx = 0; inx < element.classList.length; inx++) {
              if (element.classList[inx] === n) { return true; }
            };
            return false;
          };
          element.clt = function (t) { if (element.classList) { element.classList.toggle(t); } return element; };
          element.cla = function (t) { if (element.classList) { element.classList.add(t); } return element; };
          element.clr = function (t) { if (element.classList) { element.classList.remove(t); } return element; };
          element.ac = function (s) { s = map(s); element.appendChild(map(s)); return s; };
          element.ht = function (s) { element.innerHTML = s; return element; },
          element.chl = function (n) { if (n < 1) { n = 1; } return map(element.children[n - 1]); };
          element.qs = function (s) {
            let r = element.querySelector(s);
            if (r) { return map(r); } else if (preventNull) { return map({}); }
          };
          element.qa = function (s) {
            let r = null;
            if (element.querySelectorAll) {
              r = element.querySelectorAll(s);
            }
            if (r) {
              if (Array.isArray(r)) {
                r.forEach((e, inx) => { r[inx] = map(e); });
                return r;
              }
              else {
                let ret = [];
                Object.keys(r).forEach((inx) => { ret[inx] = map(r[inx]); });
                return ret;
              }
            } else if (preventNull) {
              return [];
            }
          };
          element.qac = function (s) {
            let ret = [];
            let list = element.qa(s);
            for (let inx = 0; inx < list.length; inx++) {
              let elo = map(document.createElement(list[inx].nodeName));
              list[inx].acpy(elo);
              ret.push(elo.html(list[inx].html()));
            }
            return ret;
          };
          element.ra = function (n) {
            element.removeAttribute(n);
            return element;
          }
          element.at = function (n, v) {
            if (v != undefined || Number.isFinite(v)) {
              element.setAttribute(n, v); 
              return element;
            }
            if (element.getAttribute) {
              return element.getAttribute(n);
            }
            else if (preventNull) {
              return "";
            }
          };
          element.html = function (v) {
            if (v != undefined || Number.isFinite(v)) {
              element.innerHTML = v
              return element;
            }
            if (element.innerHTML) {
              return element.innerHTML;
            }
            else if (preventNull) {
              return "";
            }
          };
          element.ohtml = function () {
            if (element.outerHTML) {
              return element.outerHTML;
            }
            else if (preventNull) {
              return "";
            }
          };
          element.acpy = function(e) {
            if (e) {
              let list = element.attributes;
              for (let inx = 0; list && inx < list.length; inx++) {
                e.setAttribute(list[inx].name, list[inx].value);
              }
            }
            return element;
          };
        }
        return element;
      };
      if (element == null) { return null; }
      if (element.$el) { return map(element.$el); }
      if (element.target) { return map(element.target); }
      if (typeof element === "string") { return map(document.createElement(element)); }
      return map(element);
    };

    /* 파일 확장자 판단 */
    boardUtil.fileExt = function(value) {
      let ret = ["", ""];
      let mat = /.*[.]([a-zA-Z0-9]+)$/g.exec(value);
      if (mat) {
        ret[0] = String(mat[1]).toLowerCase();

        for (let key in FILE_EXT) {
          let items = FILE_EXT[key];
          if (boardUtil.isIn(ret[0], items)) {
            ret[1] = key;
            break;
          }
        }
      }
      // console.log(ret);
      return ret;
    };

    /* 배열안에 특정 값이 있는지 확인 */
    boardUtil.isIn = function(value, list) {
      let ret = false;
      if (!list || !(list instanceof Array) || list.length == 0) { return ret; }
      if (value instanceof Array) {
        for (let inx = 0; inx < value.length; inx++) {
          if (list.indexOf(value[inx]) != -1) {
            ret = true;
            break;
          }
        }
      }
      else {
        if (list.indexOf(value) != -1) {
          ret = true;
        }
      }
      return ret;
    };

    /* 클립보드 복사 */
    boardUtil.copyClipboard = function (text) {
      let element = document.createElement("input");
      let s = element.style;
      s.border = "0";
      s.width = "1px";
      s.height = "1px";
      s.background = "#fff";
      s.color = "#fff";
      element.value = text;
      self.$el.appendChild(element);
      element.select();
      document.execCommand("copy");
      self.$el.removeChild(element);
    };

    /* 커서 위치에 텍스트 삽입 */
    boardUtil.insertAtCaret = function (newNode, root) {
      let range = document.getSelection().getRangeAt(0);
      let currentNode = range.endContainer;
      let parentNode = currentNode.parentNode;
      let nextNode = currentNode.nextSibling;
      let offset = range.endOffset;
      if (parentNode != root) {
        if (currentNode.nodeValue) {
          /* TIPTAP 에디터에서 중간삽입 */
          let prevText = currentNode.nodeValue.substring(0, offset);
          let nextText = currentNode.nodeValue.substring(offset);
          let textNode = document.createTextNode(" " + nextText);
          // console.log("PT:" + prevText + " / NT:" + nextText);
          currentNode.nodeValue = prevText;
          if (nextNode) {
            parentNode.insertBefore(newNode, nextNode);
            parentNode.insertBefore(textNode, nextNode);
          } else
          {
            parentNode.appendChild(newNode);
            parentNode.appendChild(textNode);
          }
        }
        else {
          /* div(일반) 에디터에서 중간삽입 */
          let textNode = document.createTextNode(" ");
          currentNode.appendChild(newNode);
          currentNode.appendChild(textNode);
        }
        newNode.focus();
        document.getSelection().collapse(newNode, 1);
      }
      else {
        /* 에디터 최초입력 */
        let textNode = document.createTextNode(" ");
        if (!currentNode.innerText.replace(/[ \t\r\n]+/g, "")) {
          currentNode.innerHTML = "<span></span>";
        }
        currentNode.appendChild(newNode);
        currentNode.appendChild(textNode);
        newNode.focus();
        document.getSelection().collapse(newNode, 1);
      }
      return newNode;
    };

    /* 복수의 난수 생성 */
    boardUtil.rnums = function (range, num) {
      let ret = [];
      for (let inx = 0; inx < num; inx++) {
        let rnd = Math.floor(Math.abs(Math.random() * range));
        ret.push(rnd);
      }
      return ret;
    };

    /* 특정 객체에 다단계 하위객체 존재여부 체크 */
    boardUtil.hasSub = function(obj, keys) {
      if (!obj) { return false; }
      if (!keys || keys.length == 0 || !(keys instanceof Array)) { return obj; }
      let target = obj;

      for (let inx = 0; inx < keys.length; inx++) {
        if (!target[keys[inx]]) {
          target = null;
          break;
        }
        target = target[keys[inx]];
      }
      return target;
    };

    /* 점유하고 있는 블럭을 점유 해지한다 (페이지 이동시) */
    boardUtil.clearBlockLock = function() {
      let editor = self.$refs.boardEditor;
      if (editor && editor.state.blockOwned) {
        let block = editor.state.blockOwned;
        let param = {
          uri: "/block/blockLockYn",
          param: {
            paperId: String(self.paperInfo.paperId),
            paperBlockId: String(block.bdata.paperBlockId),
            blockLockYn: "0",
            updateToken: ""
          }
        };
        boardUtil.apiCall(param);
      }
    };

    boardUtil.matchBoardURL = function(url) {
      url = boardUtil.trim(url);
      return/^(.+)\/(board|boardViewer)\/(PAPE[a-zA-Z0-9]+)([/].*){0,1}/.exec(url);
    };

    /* 보드 URL */
    boardUtil.currentURL = function() {
      let url = window.location.href;
      let match = boardUtil.matchBoardURL(url);
      if (match && match.length > 3) {
        url = match[1] + "/board/" + match[3];
      }
      return url;
    };

    /* 소켓에 접속 후 인자로 전달된 콜백함수를 실행 */
    boardUtil.apiCall = function(arg) {
      if (!arg) { return; }
      /**
       * 다음 순으로 실행된다
       * axiosCallback(STOMP 콜백) -> arg.callback(인자 콜백)
       **/
      let baseURL = "/api/copaper/paper";
      /* AXIOS 콜백함수 */
      let axiosCallback = (arg) => {
        if (arg.param) {
          axios
            .post(baseURL + arg.uri, arg.param)
            .then((res) => {
              /* 인자 콜백이 있는경우 실행 */
              if (arg.callback) { arg.callback(res); }
            })
            .catch((err) => {
              console.log("axios err => ", err);
              if (arg.errCallback) {
                arg.errCallback();
              }
            });
        }
      };
      /* 넘겨받은 인자가 체인 (어레이) 인 경우 연속 실행 */
      if (arg instanceof Array) {
        arg.forEach((param) => { axiosCallback(param); });
      } else {
        /* 넘겨받은 인자가 일반 객체 인 경우 단독실행 */
        axiosCallback(arg);
      }
    };

    boardUtil.getLinkMeta = function(link, callback) {
      let url = "/api/copaper/paperblock/getLinkMeta";
      let param = { link: link };
      axios
        .post(url, param)
        .then((res) => {
          let result = {};
          if (res.data.result) { result = res.data.result; }
          if (result.data && Object.keys(result.data).length > 0) {
            let data = result.data;
            let metaTag = document.createElement("a");
            metaTag.innerHTML = link;
            for (let key of ["title", "image", "description", "linkType"]) {
              metaTag.setAttribute("data-meta-" + key, data[key] ? data[key] : "");
            }
            if (callback) { callback(true, data, metaTag); }
          }
          else {
            if (callback) { callback(false); }
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
          if (callback) { callback(false); }
        });
    };
  },
  /* /BoardContent */

  /* BoardEditor 에서 활성화 시킬수 있는 함수들 */
  initBoardEditor(self, blockConstructor) {
    self.tracelog = tracelog;
    let boardUtil = this;
    let blockTypes = boardUtil.blockTypes;
    let ownTypes = boardUtil.ownTypes;
    boardUtil.blockConstructor = blockConstructor;

    /* 블럭들을 정렬 level 0일경우 blockId만, level 1일경우 DOM 까지 정렬 */
    boardUtil.sortPaperBlocks = function(level = 0) {
      self.paperBlockIdList.sort(function(blockId1, blockId2) {
        return self.paperBlockMap[blockId1].bdata.sortNo * 1-
          self.paperBlockMap[blockId2].bdata.sortNo * 1;
      });
      if (level > 0 && self.$refs.contentBlocks) {
        self.$refs.contentBlocks.sort(function(block1, block2) {
          if (block1.bdata != undefined && block2.bdata != undefined) {
            block1 = block1.bdata;
            block2 = block2.bdata;
          }
          return block1.sortNo * 1 - block2.sortNo * 1;
        });
      }
    };

    /* 블럭 삭제함수 */
    boardUtil.removeBlockData = function(paperBlockId) {
      let item = self.paperBlockMap[paperBlockId];
      try { delete item.bdata; } catch (e) { };
      try { delete item.component; } catch (e) { };
      try { delete item.element; } catch (e) { };
      try { delete self.transmitter.subscribers[blockId] } catch (e) { };
      try { delete self.paperBlockMap[paperBlockId] } catch (e) { };
      let inx = self.paperBlockIdList.indexOf(paperBlockId);
      if (inx != -1) {
        self.paperBlockIdList.splice(inx, 1);
      }
    };

    /* 임시메소드 (테스트중) */
    boardUtil.getPaperBlock = function (paperBlockId, dir = 0) {
      return self.paperBlockMap[paperBlockId];
    };

    /* 업데이트 토큰을 입력한다 */
    boardUtil.addUpdateToken = function (updateToken) {
      let tokens = boardUtil.updateTokens;
      let found = boardUtil.findUpdateToken(updateToken);
      if (found == -1) {
        tokens.push({ token: updateToken, time: new Date().getTime() });
      }
    };

    /* 업데이트 토큰을 찾는다 */
    boardUtil.findUpdateToken = function (updateToken) {
      let ret = -1;
      let currentTime = new Date().getTime();
      let tokens = boardUtil.updateTokens;
      for (let inx = 0; inx < tokens.length; inx++) {
        /* 1분이 넘은 토큰은 무효처리 */
        if (tokens[inx].time > currentTime + 60000) {
          tokens.splice(inx, 1);
          inx--;
          continue;
        }
        if (tokens[inx].token === updateToken) {
          ret = inx;
          break;
        }
      }
      return ret;
    };

    /* 업데이트 토큰을 삭제한다 */
    boardUtil.removeUpdateToken = function (updateToken) {
      let tokens = boardUtil.updateTokens;
      let found = boardUtil.findUpdateToken(updateToken);
      if (found != -1) {
        tokens.splice(found, 1);
      }
    };

    /* 표에서 각 칼럼들의 폭을 인식 */
    boardUtil.getTableColumnWidths = function (elem, colWidths) {
      elem = boardUtil.$dm(elem, 1);
      let rows = elem.qa("tr");
      for (let rinx = 0; rinx < rows.length; rinx++) {
        let cols = rows[rinx].qa("td, th");
        if (cols && cols.length > 0) {
          for (let cinx = 0; cinx < cols.length; cinx++) {
            let widths = cols[cinx].at("data-colwidth");
            if (widths) {
              let wList = widths.split(/[,]/g);
              for (let winx = 0; winx < wList.length; winx++) {
                colWidths.push(wList[winx]);
              }
            }
            else { colWidths.push(0); }
          }
          break;
        }
      }
    };

    /* 표에서 각 칼럼들의 폭을 재계산 */
    boardUtil.updateTableColumnWidths = function (elem, colWidths, width1, width2) {
      // elem = boardUtil.$dm(elem, 1);
      // let widthRatio = (width1 * 1) / (width2 * 1);
      // if (isNaN(widthRatio) || !isFinite(widthRatio)) { widthRatio = 1; }
      // let tmp = [];
      // for (let inx = 0; inx < colWidths.length; inx++) {
      //   tmp[inx] = Math.round(widthRatio * colWidths[inx]);
      // }
      // colWidths = tmp;
      // let rows = elem.qa("tr");
      // for (let rinx = 0; rinx < rows.length; rinx++) {
      //   rows[rinx].at("style", "display:table-row");
      //   let cols = rows[rinx].qa("td, th");
      //   if (cols && cols.length > 0) {
      //     let pinx = 0;
      //     for (let cinx = 0; cinx < cols.length; cinx++) {
      //       if (cinx != (cols.length - 1)) {
      //         let widths = cols[cinx].at("data-colwidth");
      //         if (widths) {
      //           let cwidth = 0;
      //           let wList = widths.split(/[,]/g);
      //           for (let winx = 0; winx < wList.length; winx++) {
      //             cwidth += colWidths[pinx];
      //             wList[winx] = colWidths[pinx++];
      //           }
      //           cols[cinx].at("data-colwidth", wList.join(","));
      //           // cols[cinx].at("style", "width:" + cwidth + "px; padding:0 !important");
      //           cols[cinx].style.width = cwidth + "px";
      //         }
      //         else {
      //           let cwidth = colWidths[pinx];
      //           let width = colWidths[pinx++];
      //           cols[cinx].at("data-colwidth", width);
      //           // cols[cinx].at("style", "width:" + cwidth + "px; padding:0 !important");
      //           cols[cinx].style.width = cwidth + "px";
      //         }
      //       } else {
      //         let cwidth = 0;
      //         cols[cinx].at("data-colwidth", 0);
      //         // cols[cinx].at("style", "width:" + cwidth + "px; padding:0 !important");
      //         cols[cinx].style.width = cwidth + "px";
      //       }
      //     }
      //   }
      // }
      // let cols = elem.qa("colgroup col");
      // if (cols) {
      //   elem.style.width = width1 + "px";
      //   for (let inx = 0; inx < cols.length; inx++) {
      //     if (colWidths[inx]) {
      //       cols[inx].style.width =
      //         Math.round(widthRatio * colWidths[inx]) + "px";
      //     }
      //   }
      // }
      // // console.log(elem.outerHTML);
    };

    /* VUE 에서 DOM엘리먼트가 생성되면 맵에 매칭시켜준다 */
    boardUtil.domCreated = function(callback) {
      CHECK_AND_LAUNCH({}, { check(ctx) {
        let tmpList = [];
        let contentBlockList = self.$refs.contentBlocks;
        self.paperBlockIdList.forEach(paperBlockId => { tmpList.push(paperBlockId); });
        for (let cinx = 0; contentBlockList && cinx < contentBlockList.length; cinx++) {
          let dinx = tmpList.indexOf(contentBlockList[cinx].bdata.paperBlockId);
          if (dinx != -1) { tmpList.splice(dinx, 1); }
        }
        return tmpList.length == 0;
      }, launch(ctx) {
        let contentBlockList = self.$refs.contentBlocks;
        for (let cinx = 0; contentBlockList && cinx < contentBlockList.length; cinx++) {
          let contentBlock = contentBlockList[cinx];
          let paperBlockId = contentBlock.bdata.paperBlockId;
          if (self.paperBlockMap[paperBlockId] && !self.paperBlockMap[paperBlockId].element) {
            self.paperBlockMap[paperBlockId].element = contentBlock;
          }
        }
        boardUtil.sortPaperBlocks(1);
        if (callback) {
          callback();
        }
      } });
    };

    boardUtil.blockDomCreated = (paperBlockId, callback) => {
      CHECK_AND_LAUNCH({}, { check(ctx) {
        let block = self.$el.querySelector("div[data-block-id='" + paperBlockId + "'");
        return (ctx.block = block);
      }, launch(ctx) {
        for (let block of self.$refs.contentBlocks) {
          if (block.bdata.paperBlockId == paperBlockId) {
            self.paperBlockMap[paperBlockId].element = block;
            // console.log("BLOCK:", block);
            break;
          }
        }
        if (callback) {
          callback();
        }
      } });
    };

    boardUtil.genColorStyle = function() {
      /* 정해진 컬러표를 사용해 각종 컬러스타일을 만든다. (본문에 스타일 생성하여 삽입) */
      let styles = "";
      let nl = "\r\n";
      let colors = boardUtil.colors;
      for (let inx = 0; inx < colors.length; inx++) {
        styles += ".hw-color-bg-" + inx + "{" + nl + "background:" + colors[inx] + ";" + nl + "}" + nl;
        styles += ".hw-color-fg-" + inx + "{" + nl + "color:" + colors[inx] + ";" + nl + "}" + nl;
        styles += ".hw-tb-color-" + inx + " th" + "{" + nl + "background:" + colors[inx] + ";" + nl + "}" + nl;
        styles += ".hw-tb-color-" + inx + " th" + "{" + nl + "color:" + 
          (inx == 2 || inx == 3 || inx == 4 || inx == 5 || inx == 6 ? "#000" : "#fff") + ";" + nl + "}" + nl;
        styles += ".hw-table-cell-color-bg-" + inx + "{" + nl + "background:" + (inx !== 3 ? colors[inx] : "#fff") + ";" + nl + "}" + nl; /** 표 버블 메뉴의 색상 설정 시, 흰색 설정 **/
      }
      let element = document.createElement("style");
      element.innerText = styles;
      self.$el.appendChild(element);
    };

    boardUtil.trim = function(text) {
      text = text.replace(/^[  \t\r\n\0]+/, "");
      text = text.replace(/[  \t\r\n\0]+$/, "");
      text = text.replace(/^[\r\n]{0,1}$/g,"");
      return text;
    }

    boardUtil.matchUrl = function(url) {
      url = boardUtil.trim(url);
      return /^((http|https):\/\/([a-zA-Z0-9._-]+)([:][0-9]+){0,1})(\/.*){0,1}/.exec(url);
    };

    /* 키보드로 블럭간 이동 (상하좌우 키) */
    boardUtil.gotoEditorBlock = function(blockId, direction) {
      let element = null;
      let tmp = null;

      let blockList = self.paperBlockIdList;
      let blockMap = self.paperBlockMap;

      boardUtil.sortPaperBlocks(1);
      let blockIndex = blockList.indexOf(blockId);

      element = blockMap[blockId].element;

      if (!direction) {
        for (let inx = blockIndex - 1; inx >= 0; inx--) {
          if ((tmp = blockMap[blockList[inx]].bdata.blockType) &&
            tmp === blockTypes.CONTENT) {
            // (tmp === blockTypes.CONTENT || tmp === blockTypes.TABLE)) {
            let block = blockMap[blockList[inx]];
            if ((tmp = block.element.checkLockOwn()) === ownTypes.NOBODY || tmp === ownTypes.OWNER) {
              boardUtil.blurPrevFocusedBlock(block.element);
              /* 커서 밀림현상 때문에 지연시간을 둠 */
              setTimeout(() => {
                boardUtil.focusBlock(block.element, -1, false);
                /* 커서를 맨 마지막으로 이동 */
                let elist = block.element.$el.querySelector("div[contenteditable]").childNodes;
                let editor = block.element.editor;
                let contentSize = editor.view.state.doc.content.size
                editor.setSelection(contentSize, contentSize);
                let sel = document.getSelection();
                if (elist && sel) { sel.collapse(elist[elist.length - 1], 1); }
              }, 10);
            }
            else {
              console.log("다른 사용자가 작성중입니다. (" + blockIndex + " / " + inx + " / " + block.bdata.blockLockName + ")");
            }
            break;
          }  else if ((tmp = blockMap[blockList[inx]].bdata.blockType) && tmp === blockTypes.TABLE) {
              /* 
                일자    : 2021.08.31.
                작성자  : 윤태진
                이동하려는 대상 블럭이 테이블일 경우, 테이블의 첫번째 셀로 이동
              */
              let block = blockMap[blockList[inx]];
              boardUtil.blurPrevFocusedBlock(block.element);
              setTimeout(() => {
                boardUtil.focusBlock(block.element, 1, false);
                //let elist = block.element.$el.querySelector("div[contenteditable]").childNodes[0].childNodes[0].childNodes[0].childNodes[1].childNodes[0].childNodes[0].childNodes[0];
                let elist = block.element.$el.querySelector("div[contenteditable]").querySelector("table").querySelectorAll("tr")[0].childNodes[0].childNodes[0];
                let editor = block.element.editor;
                editor.setSelection(0, 0);
                let sel = document.getSelection();
                if (elist && sel) { 
                  sel.collapse(elist, 0); 
                  elist.classList.add('has-focus'); // 2021-11-16 방향키로 표 셀에 접근 후, 엔터 누르면 표가 밀려나면서 표 상단에 p 태그가 추가되어 조치
                }
              }, 10);
              break;
          }
          else {
            boardUtil.blurPrevFocusedBlock(element);
          }
        }
      }
      else {
        for (let inx = blockIndex + 1; inx < blockList.length; inx++) {
          if ((tmp = blockMap[blockList[inx]].bdata.blockType) &&
            tmp === blockTypes.CONTENT) {
            // (tmp === blockTypes.CONTENT || tmp === blockTypes.TABLE)) {
            let block = blockMap[blockList[inx]];
            if ((tmp = block.element.checkLockOwn()) === ownTypes.NOBODY || tmp === ownTypes.OWNER) {
              boardUtil.blurPrevFocusedBlock(block.element);
              /* 커서 밀림현상 때문에 지연시간을 둠 */
              setTimeout(() => {
                boardUtil.focusBlock(block.element, 1, false);
                /* 커서를 맨 처음으로 이동 */
                let elist = block.element.$el.querySelector("div[contenteditable]").childNodes;
                block.element.editor.setSelection(0, 0);
                let sel = document.getSelection();
                if (elist && sel) { sel.collapse(elist[0], 0); }
              }, 10);
            }
            else {
              console.log("다른 사용자가 작성중입니다. (" + blockIndex + " / " + inx + " / " + block.bdata.blockLockName + ")");
            }
            break;
          }
          else if ((tmp = blockMap[blockList[inx]].bdata.blockType) && tmp === blockTypes.TABLE) {
            /* 
              일자    : 2021.08.31.
              작성자  : 윤태진
              이동하려는 대상 블럭이 테이블일 경우, 테이블의 첫번째 셀로 이동
            */
            let block = blockMap[blockList[inx]];
            boardUtil.blurPrevFocusedBlock(block.element);
            setTimeout(() => {
              boardUtil.focusBlock(block.element, 1, false);
              let elist = block.element.$el.querySelector("div[contenteditable]").querySelector("table").querySelectorAll("tr")[0].childNodes[0].childNodes[0];
              let editor = block.element.editor;
              editor.setSelection(0, 0);
              let sel = document.getSelection();
              if (elist && sel) { 
                sel.collapse(elist, 0);
                elist.classList.add('has-focus'); // 2021-11-16 방향키로 표 셀에 접근 후, 엔터 누르면 표가 밀려나면서 표 상단에 p 태그가 추가되어 조치
              }
            }, 10);
            break;
          }
          else {
            boardUtil.blurPrevFocusedBlock(element);
          }
        }
      }
    };

    /* 블럭끼리 병합 (텍스트블럭 인 경우. Backspace, Delete 키) */
    boardUtil.mergeEditorBlock = function(blockId, direction) {
      let elementPrev = null;
      let element = null;
      let content = "";
      let map = null;
      let tmp = null;

      let blockList = self.paperBlockIdList;
      let blockMap = self.paperBlockMap;
      boardUtil.sortPaperBlocks(1);
      let blockIndex = blockList.indexOf(blockId);

      if (blockIndex < 0 || !blockMap[blockList[blockIndex]]) {
        console.log("block error! " + blockIndex + " / " + blockMap[blockList[blockIndex]]);
        return;
      }

      /* 0 : 위로 병합, 1 : 아래로 병합 */
      if (!direction) {
        element = blockMap[blockId].element;
        // console.log("E:", element);
        if (blockIndex >= 0 && element) {
          content = element.editor ? element.editor.getHTML() : "";
          content = "<p></p>" + content.replace(/^(<p[ ]{0,1}[^>]*>(<br[\/]{0,1}>){0,}<[\/]p>){1,2}/, "");
          if (blockIndex >= 1 && (map = blockMap[blockList[blockIndex - 1]]) &&
            map.bdata.blockType === blockTypes.CONTENT) {
            if ((tmp = map.element.checkLockOwn()) === ownTypes.NOBODY || tmp === ownTypes.OWNER) {
              elementPrev = element;
              element = map.element;
              let length = element.editor.state.doc.content.size;
              content = element.editor.getHTML() + "" + content;
              element.editor.setContent(content);
              element.html = content;
              elementPrev.$el.classList.add("hidden");
              elementPrev.state.handleSubmit = -1;
              element.updateBlock();
              elementPrev.deleteBlock({ blockMoveTo: element.bdata.paperBlockId });
              element.$nextTick(() => {
                boardUtil.focusBlock(element, length, true);
                setTimeout(() => { element.caretPosition(length); }, 80);
              });
              boardUtil.removeBlockData(elementPrev.bdata.paperBlockId);
            }
            else {
              console.log("다른 사용자가 작성중입니다." + blockIndex + " : " + map.bdata.paperBlockId);
            }
          }
          else {
            if (self.contentText(element.html).length == 0) {
              element.cancelBlur(element.deleteBlock);
            }
            if (blockIndex > 0) {
              /* 위로 블럭이 있는 경우에만 삭제한다 */
              element = blockMap[blockList[blockIndex - 1]].element;
              if (element.blockType() === blockTypes.LINE) {
                element.deleteBlock();
              }
            }
          }
          boardUtil.blurPrevFocusedBlock(element);
          boardUtil.focusBlock(element);
        }
      }
      else {
        if (blockIndex + 1 < blockList.length) {
          element = blockMap[blockList[blockIndex + 1]].element;
        }
        // console.log("E:", element);
        if (element && element.bdata.blockType == blockTypes.CONTENT && blockIndex + 1 < blockList.length) {
          content = element.editor ? element.editor.getHTML() : "";
          content = "<p></p>" + content.replace(/(<p[ ]{0,1}[^>]*>(<br[\/]{0,1}>){0,}<[\/]p>){1,2}$/, "");
          if ((map = blockMap[blockList[blockIndex + 1]]) &&
            map.bdata.blockType === blockTypes.CONTENT) {
            if ((tmp = map.element.checkLockOwn()) === ownTypes.NOBODY || tmp === ownTypes.OWNER) {
              elementPrev = element;
              element = blockMap[blockId].element;
              let length = element.editor.state.doc.content.size;
              content = element.editor.getHTML() + "" + content;
              element.editor.setContent(content);
              element.html = content;
              elementPrev.$el.classList.add("hidden");
              elementPrev.state.handleSubmit = -1;
              element.updateBlock();

              element.$nextTick(() => {
                boardUtil.focusBlock(element, length, true);
                setTimeout(() => { element.caretPosition(length); }, 80);
              });

              elementPrev.deleteBlock({ blockMoveTo: element.bdata.paperBlockId });
              boardUtil.removeBlockData(elementPrev.bdata.paperBlockId);
            }
            else {
              console.log("다른 사용자가 작성중입니다." + blockIndex + " : " + map.bdata.paperBlockId);
            }
          }
          else {
            element = blockMap[blockId].element;
            if (self.contentText(element.html).length == 0) {
              element.cancelBlur(element.deleteBlock);
            }
            if (blockIndex < blockList.length) {
              element = blockMap[blockList[blockIndex + 1]].element;
              if (element.blockType() === blockTypes.LINE) {
                element.deleteBlock();
              }
            }
          }
          boardUtil.blurPrevFocusedBlock(element);
          boardUtil.focusBlock(element);
        }
      }
      if (self.detectImages) {
        self.detectImages();
      }
    };

    /* 블럭분할 (텍스트블럭 인 경우. 엔터두번) */
    boardUtil.splitBlock = function(block, cursor) {
      let view = block.editor.view;
      let contentPrv = "";
      let contentNext = "";
      let inx = 0;
      let clist = view.docView.children;
      for (; inx < cursor[3][0] - 1; inx++) {
        contentPrv += clist[inx].contentDOM.outerHTML;
      }
      contentNext = view.docView.contentDOM.innerHTML.substring(contentPrv.length);
      contentPrv = contentPrv.replace(/(<p[ ]{0,1}[^>]*>(<br[\/]{0,1}>){0,}<[\/]p>)/g, "<p></p>");// + "<p></p>";
      {
        contentNext = contentNext.replace(/^(<p[ ]{0,1}[^>]*>(<br[\/]{0,1}>){0,}<[\/]p>){1}/, "");
        if (contentNext) {
          let elem = document.createElement("div");
          elem.innerHTML = contentNext;
          let child = elem.firstChild;

          /** 이미지가 마지막에 있는 경우 이미지 선택하여 엔터 2번쳐서 split할 경우 이미지 사라지는 현상 개선
           * 이미지 태그를 선택하면 child.innerText 가 ""가 되기 때문에 하기 if문을 타면서 이미지가 remove 됨
           * skyoon 211022
           * */ 
          if (child.nodeName === "P" && (child.innerText != '') && !child.innerText.replace(/[ \t\r\n]/g, "")) {
            elem.removeChild(child);
            contentNext = elem.innerHTML;
          }
        }
      }
      contentNext = contentNext.replace(/(<p[ ]{0,1}[^>]*>(<br[\/]{0,1}>){0,}<[\/]p>)/g, "<p></p>");
      block.editor.setContent(contentPrv);
      block.html = contentPrv;
      block.$nextTick(() => {
        let callback = function(newBlock) {
          boardUtil.blurPrevFocusedBlock(newBlock);
          boardUtil.focusBlock(newBlock, 0, true);
          setTimeout(function() { newBlock.caretPosition(0); }, 80);
        };
        boardUtil.createTempBlock({ sortNo: block.bdata.sortNo, content: contentNext }, callback);
      });
    };

    boardUtil.createTempBlock = function(param, callback) {
      let tableMenu = document.getElementById("mock_table_bubble_menubar");
      console.log("createTempBlock");
      let sortNo = param.sortNo;
      let content = param.content;
      let blockType = param.blockType;
      let paperBlockId = param.paperBlockId;
      let blockLockYn = param.blockLockYn;
      let blockState = param.blockState;
      let index = -1;
      let blockList = self.paperBlockIdList;
      let blockMap = self.paperBlockMap;
      let res = [];
      HW_KEYGEN({}, {head: "UPDT", res});
      let updateToken = res[0];
      boardUtil.sortPaperBlocks(1);
      /* 빈 텍스트 에디터 블럭 생성 */
      /* 정렬번호를 사용해 끼워넣을 위치를 찾는다 */
      for (let inx = 0; inx < blockList.length; inx++) {
        // console.log("COMPARE:", inx, blockMap[blockList[inx]].bdata.sortNo, sortNo);
        if (blockMap[blockList[inx]].bdata.sortNo > sortNo) {
          index = inx;
          break;
        }
      }

      if (index == -1) {
        index = blockList.length;
      }

      if (!paperBlockId) {
        HW_KEYGEN({}, {head: "BLOC", res});
        paperBlockId = res[0];
      }

      if (!blockType) {
        blockType = blockTypes.CONTENT;
      }

      if (blockLockYn === undefined) {
        blockLockYn = 1;
      }

      boardUtil.addUpdateToken(updateToken);
      // console.log("INDEX:" + index + " / " + paperBlockId);

      let bdata = {
        paperId: String(self.paperInfo.paperId),
        paperBlockId: paperBlockId,
        blockType: blockType,
        contentPath: content ? content : "",
        sortNo: Number(sortNo) + 1,
        blockLockId: self.userInfo.userId,
        blockLockName: self.userInfo.userName,
        blockLockNameEn: self.userInfo.userNameEn,        
        blockLockYn: blockLockYn,
        blockState: blockState,
        regUserId: self.userInfo.userId,
        regUserName: self.userInfo.userName,
        regUserNameEn: self.userInfo.userNameEn,
        index: index
      };
      // console.log("CREATETEMP : ", index, sortNo, bdata.sortNo, bdata.paperBlockId);

      blockMap[bdata.paperBlockId] = {
        bdata: bdata,
        component: boardUtil.blockConstructor[blockType]
      };

      blockList.splice(index, 0, bdata.paperBlockId);

      for (let inx = index + 1; inx < blockList.length; inx++) {
        let block = blockMap[blockList[inx]].bdata;
        block.index = inx;
        block.sortNo++;
      }

      boardUtil.updateNewBlock({
        paperId: self.paperInfo.paperId,
        paperBlockId: bdata.paperBlockId,
        contentPath: content ? content : "",
        blockType: blockType,
        blockLockYn: blockLockYn,
        blockLockName: self.userInfo.userName,
        blockLockNameEn: self.userInfo.userNameEn,
        blockState: blockState,
        sortNo: sortNo,
        updateToken: updateToken
      });

      boardUtil.domCreated(() => {
        if (callback) {
          callback(blockMap[bdata.paperBlockId].element);
        }
      });
    };

    /* 새 블럭 생성 */
    boardUtil.addNewBlock = function(param, callback) {
      self.editorAPI("addNewBlock", param, callback);
    };

    /* 새 블럭 업데이트 */
    boardUtil.updateNewBlock = function(param, callback) {
      self.editorAPI("updateNewBlock", param, callback);
    };

    /* 키보드 커서 이동에 따른 상태 체크 */
    boardUtil.getCursorState = function(block, $anchor, depth) {
      /**
       * 커서상태 구조는 다음과 같음.
       * [
       *  [커서전체위치, 최소위치], (왼쪽 이동시 최소위치 이전으로 가는지 체크)
       *  [커서전체위치, 최종위치], (오른쪽 이동시 최종위치를 넘어가는지 체크 )
       *  [커서수직위치, 최소수직위치], (위쪽 이동시 최소수직위치 이전으로 가는지 체크)
       *  [커서수직위치, 최종수직위치], (아래쪽 이동시 최종수직위치를 넘어가는지 체크)
       * ]
       */
      let r = {
        hpos: { cur: -1, st: -1, ed: -1, },
        vpos: { cur: -1, st: -1, ed: -1, }
      };
      let ret = [[-1, -1], [-1, -1], [-1, -1], [-1, -1], [0]];
      if (!depth) {
        depth = 0;
      }
      if (!$anchor.node(depth)) {
        return ret;
      }
      let ee = function(r) {
        for (let rinx = 0; r && rinx < r.length; rinx++) {
          let c = r[rinx];
          for (let cinx = 0; c && cinx < c.length; cinx++) {
            if (c[cinx] != -1) {
              return true;
            }
          }
        }
        return false;
      };

      let pos = $anchor.pos;
      let length = block.editor.state.doc.content.size;
      let content = $anchor.node(depth).content.toJSON();
      let index = $anchor.index(depth);
      let last = content.length - 1;
      if (!content[index]) {
        return ret;
      }
      let type = content[index].type;
      let startType = null;
      startType = content[0].type;
      if (depth == 0) {
        if (startType === "paragraph") {
          ret[0] = [pos, 1];
          ret[2] = [index, 0];
        }
        else if (startType === "heading") {
          ret[0] = [pos, 1];
          ret[2] = [index, 0];
        }
        else if (startType === "table") {
          ret[0] = [pos - 3, 1];
          ret[2] = [index, 0];
        }
        else if (startType === "ordered_list") {
          ret[0] = [pos - 2, 1];
          ret[2] = [index, 0];
        }
        else if (startType === "bullet_list") {
          ret[0] = [pos - 2, 1];
          ret[2] = [index, 0];
        }
        else if (startType === "wrap_element") {
          ret[0] = [pos - 4, 1];
          ret[2] = [index, 0];
        }
        else {
          console.log("UNKNOWN START TAG : " + startType);
        }
      }

      if (type === "paragraph") {
        ret[1] = [pos + 1, length];
        ret[3] = [index, last];
        ret[4] = depth;
      }
      else if (type === "heading") {
        ret[1] = [pos + 1, length];
        ret[3] = [index, last];
        ret[4] = depth;
      }
      else if (type === "table") {
        let r = boardUtil.getCursorState(block, $anchor, depth + 1);
        if (ee(r)) {
          ret[1] = [r[1][0] + 1, r[1][1]];
          ret[3] = [index + r[3][0], last + r[3][1]];
          ret[2][0] = index + r[3][0];
          ret[4] = r[4];
        }
      }
      else if (type === "table_row") {
        let r = boardUtil.getCursorState(block, $anchor, depth + 1);
        if (ee(r)) {
          ret[1] = [r[1][0] + 1, r[1][1]];
          ret[3] = [index, last];
          ret[4] = r[4];
        }
      }
      else if (type === "table_header") {
        let r = boardUtil.getCursorState(block, $anchor, depth + 1);
        if (ee(r)) {
          ret[1] = [r[1][0] + 1, r[1][1]];
          ret[4] = depth;
        }
      }
      else if (type === "table_cell") {
        let r = boardUtil.getCursorState(block, $anchor, depth + 1);
        if (ee(r)) {
          ret[1] = [r[1][0] + 1, r[1][1]];
          ret[4] = depth;
        }
      }
      else if (type === "ordered_list") {
        let r = boardUtil.getCursorState(block, $anchor, depth + 1);
        if (ee(r)) {
          ret[1] = [r[1][0] + 1, r[1][1]];
          ret[3] = [index + r[3][0], last + r[3][1]];
          ret[4] = r[4];
        }
      }
      else if (type === "bullet_list") {
        let r = boardUtil.getCursorState(block, $anchor, depth + 1);
        if (ee(r)) {
          ret[1] = [r[1][0] + 1, r[1][1]];
          ret[3] = [index + r[3][0], last + r[3][1]];
          ret[4] = r[4];
        }
      }
      else if (type === "list_item") {
        let r = boardUtil.getCursorState(block, $anchor, depth + 1);
        if (ee(r)) {
          ret[1] = [r[1][0] + 1, r[1][1]];
          ret[3] = [index + r[3][0], last + r[3][1]];
          ret[4] = depth;
        }
      }
      else if (type === "wrap_element") {
        let r = boardUtil.getCursorState(block, $anchor, depth + 1);
        if (ee(r)) {
          ret[1] = [r[1][0] + 1, r[1][1]];
          ret[3] = [index + r[3][0], last + r[3][1]];
          ret[4] = r[4];
        }
      }
      else {
        console.log("UNKNOWN TAG : " + type);
      }
      if (depth == 0) {
        // console.log("CHECK:" + index + " / " + last + " / " + startType + ":" + type + " / " + JSON.stringify(ret));
      }
      if (ret[0][0] < ret[0][1]) {
        ret[0][0] = ret[0][1];
      }
      if (ret[1][0] > ret[1][1]) {
        ret[1][0] = ret[1][1];
      }
      if (ret[2][0] < ret[2][1]) {
        ret[2][0] = ret[2][1];
      }
      if (ret[3][0] > ret[3][1]) {
        ret[3][0] = ret[3][1];
      }
      return ret;
    };

    /* 현재 선택된 블럭 (클릭 등에 의해) */
    boardUtil.ownBlock = function(block) {
      boardUtil.blockOwned = block;
    };

    /* 선택된 블럭 포커싱 */
    boardUtil.focusBlock = function(blockCurrent, caretPosition = -1, forcely) {
      tracelog("UTIL-FOCUS");
      if (blockCurrent) {
        if (blockCurrent.checkLockOwn() === ownTypes.NOBODY) {
          if (caretPosition != -1 && blockCurrent != boardUtil.blockOwned) {
            // blockCurrent.caretPosition(caretPosition);
          }
          blockCurrent.focus(forcely);
          boardUtil.blockOwned = blockCurrent;
          // console.log("OWN-BLOCK:" + boardUtil.blockOwned.bdata.paperBlockId);
          if (blockCurrent.setEnableEditable) {
            blockCurrent.setEnableEditable();
          }
        }
        else if (blockCurrent.checkLockOwn() === ownTypes.OWNER) {
          if (caretPosition != -1 && blockCurrent != boardUtil.blockOwned) {
            // blockCurrent.caretPosition(caretPosition);
          }
          blockCurrent.focus(forcely);
        }
      }
    };

    /* 이전블럭을 포커스 해지 */
    boardUtil.blurPrevFocusedBlock = function(blockCurrent) {
      tracelog("BLUR-PREV");
      let ret = null;
      let blocks = self.$refs.contentBlocks;
      for (let inx = 0; blocks && inx < blocks.length; inx++) {
        let bdata = blocks[inx].bdata;
        if (blocks[inx] != blockCurrent && blocks[inx].checkLockOwn() === ownTypes.OWNER) {
          // console.log("FREE-BLOCK:" + blocks[inx].bdata.paperBlockId);
          blocks[inx].setDisableEditable();
        }
      }
      let blockPrev = boardUtil.blockOwned;
      if (blockPrev && blockPrev != -1 && blockPrev != blockCurrent && 
        blockPrev.checkLockOwn() === ownTypes.OWNER) {
        blockPrev.blur();
        ret = blockPrev;
        // console.log("FREE-BLOCK:" + blockPrev.bdata.paperBlockId);
        blockPrev.setDisableEditable();
        boardUtil.blockOwned = null;
      }
      return ret;
    };

    boardUtil.copyKbdAttr = function(e, state) {
      state.keyCode = e.keyCode;
      state.ctrlKey = e.ctrlKey;
      state.altKey = e.altKey;
      state.shiftKey = e.shiftKey;
      state.target = e.target;
    };

    boardUtil.fillNBSP = function(elem) {
      if (elem) {
        let list = elem.querySelectorAll("p");
        for (let inx = 0; inx < list.length; inx++) {
          let pelem = list[inx];
          if (!pelem.innerHTML) {
            pelem.innerHTML = "&nbsp;";
          }
        }
      }
    };

    boardUtil.isTestMode = function() {
      return testmode;
    };

    boardUtil.tracelog = tracelog;
    boardUtil.dumpAttr = dumpAttr;
    
    boardUtil.bindEvent = function(el, type, handler) {
      if (el.attachEvent) {
        el.attachEvent("on" + type, handler); 
      } else {
        el.addEventListener(type, handler);
      }
    };

    boardUtil.unbindEvent = function (el, type, handler) {
      if (el.detachEvent) {
        el.detachEvent("on" + type, handler);
      } else {
        el.removeEventListener(type, handler);
      }
    };

    // DLP 개인정보 필터링 차단 메시지 
    boardUtil.makeDLPErrorMsg = function (target, orgErrorMessage) {
      if ( target.tenantId === "201" ) {
        let errorMessage = JSON.parse(orgErrorMessage);
        let message = target.$i18nUtil.trans("AB076");

        if (errorMessage.detectedFiles != null && errorMessage.detectedFiles.length > 0 ) {
          let detectedFiles = errorMessage.detectedFiles[0];
          if (detectedFiles.data != null && detectedFiles.data.length > 0) {
            let displayIndex = 50;
            const patternMap = new Map();
            patternMap.set("주민번호", "AB076.001");
            patternMap.set("외국인등록번호", "AB076.002");
            patternMap.set("여권번호", "AB076.003");
            patternMap.set("운전면허번호", "AB076.004");
            patternMap.set("건강보험번호", "AB076.005");
            patternMap.set("휴대전화번호", "AB076.006");
            patternMap.set("신용카드번호", "AB076.007");
            patternMap.set("계좌번호", "AB076.008");
            patternMap.set("사업자번호", "AB076.009");
            patternMap.set("이메일", "AB076.010");

            detectedFiles.data.forEach((detectedFilesData, index) => {
              let pattern = detectedFilesData.pattern;
              if (patternMap.has(pattern) && detectedFilesData.count > 0) {
                let content = detectedFilesData.content;

                if (content.length > displayIndex) {
                  content = content.substr(0, displayIndex) + "...";
                }

                message += "\n" + (index + 1) + ". "
                  + target.$i18nUtil.trans(patternMap.get(pattern), { cnt: detectedFilesData.count, content: content });
              }
            });
          }
        }

        target.showAlertDialog(message, null, {
          width: "600px"
        });
      } else {
        target.showAlertDialog(target.$i18nUtil.trans("AB076"));
      }
      return;
    };
    //
  },
  /* /BoardEditor */
}

export default BoardUtil


// WEBPACK FOOTER //
// ./src/components/cowork/general/board/base/BoardUtil.js